import FeatureAccess from "./feature_access";

export { FeatureAccess };